// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

html, body {
  overflow-y: hidden; /* Prevent vertical scrolling */
  height: 100%;
}

code {
    font-family: 'Assistant';
}


#root {
  overflow-y: auto; /* Allow scrolling within the root element */
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;;IAET,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;EACE,kBAAkB,EAAE,+BAA+B;EACnD,YAAY;AACd;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;EACE,gBAAgB,EAAE,4CAA4C;EAC9D,YAAY;AACd","sourcesContent":["body {\n    margin: 0;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\nhtml, body {\n  overflow-y: hidden; /* Prevent vertical scrolling */\n  height: 100%;\n}\n\ncode {\n    font-family: 'Assistant';\n}\n\n\n#root {\n  overflow-y: auto; /* Allow scrolling within the root element */\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
